<template>
  <div id="offer-form" class="modal-form" v-if="formData">
    <div class="container-fluid">
      <div class="row justify-content-center">
        <div class="col-md-8">
          <form class="formData-form" @submit.prevent="onSubmit">
            <div class="row">
              <div class="col-md-3">
                <input
                  type="submit"
                  class="btn btn-primary form-control"
                  value="Save &amp; Publish"
                  @click="saveAndPublish"
                  :disabled="!formData.isAcceptedEnwokeAgreement"
                />
              </div>
              <div class="col-md-3">
                <button
                  class="btn btn-secondary form-control"
                  @click="unpublish"
                  :disabled="!formData.isAcceptedEnwokeAgreement"
                >
                  Unpublish
                </button>
              </div>
              <div class="col-md-3">
                <button
                  class="btn btn-secondary form-control"
                  @click="saveDraft"
                  :disabled="!formData.isAcceptedEnwokeAgreement"
                >
                  Save
                </button>
              </div>
              <div class="col-md-3">
                <button
                  class="btn btn-secondary close-button form-control"
                  @click="onClickCloseButton"
                >
                  Close
                </button>
              </div>
            </div>
            <h1 class="form-title">Add/Edit Story</h1>
            <fieldset>
              <legend>
                <div class="row">
                  <div class="col">Basic information</div>
                  <!-- <div class="col d-flex text-right">
                    <small class="mr-3" style="width: 50%">Language</small>
                    <div style="width: 50%">
                      <select class="form-control">
                        <option value>Manage language</option>
                      </select>
                    </div>
                  </div>-->
                </div>
              </legend>
              <div class="form-group row">
                <!-- Title -->
                <label for="title" class="form-label col-md-2"
                  >Story Title*</label
                >
                <div class="col-md-10">
                  <input
                    type="text"
                    class="form-control"
                    id="title"
                    placeholder="Put a short and informative title here"
                    required
                    v-model="$v.formData.title.$model"
                    :class="{
                      'is-invalid': $v.formData.title.$error,
                      'is-valid':
                        $v.formData.title.$error == false &&
                        $v.formData.title.$model != '',
                    }"
                  />
                  <div class="invalid-feedback">Please enter a title.</div>
                </div>
              </div>
              <div class="form-group row">
                <!-- Author -->
                <label for="author" class="form-label col-md-2">Author*</label>
                <div class="col-md-10">
                  <input
                    type="text"
                    class="form-control"
                    id="author"
                    placeholder="Author of the story"
                    required
                    v-model="$v.formData.author.screenName.$model"
                    :class="{
                      'is-invalid': $v.formData.author.screenName.$error,
                      'is-valid':
                        $v.formData.author.screenName.$error == false &&
                        $v.formData.author.screenName.$model != '',
                    }"
                  />
                  <div class="invalid-feedback">Please enter a author.</div>
                </div>
              </div>
              <div class="form-group row">
                <!-- Author Image  -->
                <label for="terms" class="form-label col-md-2"
                  >Author Image:</label
                >
                <div class="col-md-10">
                  <div>
                    <ImageUploadButton
                      newColor="var(--story-color)"
                      ref="imageAuthorUploader"
                      :imageUrl="
                        formData && formData.author && formData.author.picture
                          ? formData.author.picture
                          : ''
                      "
                      @clear="onClearUploadImageAuthor"
                    />
                  </div>
                </div>
              </div>
              <div class="form-group row">
                <!-- Publication -->
                <label for="Extract" class="form-label col-md-2 pt-5"
                  >Publication</label
                >
                <div class="col-md-10">
                  <div class="row">
                    <div class="col-md-2">
                      <div class="form-check">
                        <input
                          class="form-check-input"
                          type="radio"
                          name="exampleRadios"
                          id="exampleRadios1"
                          value="now"
                          style="margin-top: 10px"
                          v-model="status"
                          @change="resetDatetime()"
                        />
                        <label class="form-check-label" for="exampleRadios1"
                          >Now</label
                        >
                      </div>
                    </div>
                    <div class="col-md-2">
                      <div class="form-check">
                        <input
                          class="form-check-input"
                          type="radio"
                          name="exampleRadios"
                          id="exampleRadios2"
                          value="schedule"
                          style="margin-top: 10px"
                          v-model="status"
                        />
                        <label class="form-check-label" for="exampleRadios2"
                          >Schedule</label
                        >
                      </div>
                    </div>
                    <div class="col-md-4">
                      <input class="form-control" type="date" v-model="date" />
                    </div>
                    <div class="col-md-4">
                      <input class="form-control" type="time" v-model="time" />
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-group row">
                <!-- Extract -->
                <label for="Extract" class="form-label col-md-2">Extract</label>
                <div class="col-md-10">
                  <textarea
                    type="text"
                    class="form-control"
                    id="Extract"
                    placeholder="Write a short extract of your story here"
                    rows="5"
                    v-model="formData.description"
                  />
                </div>
              </div>
            </fieldset>
            <fieldset>
              <legend>Target Group*</legend>
              <TravelerTypePicker
                v-model="$v.formData.travelerTypes.$model"
                selectText="Stories"
                :class="{
                  'is-invalid': $v.formData.travelerTypes.$error,
                  'is-valid':
                    $v.formData.travelerTypes.$error == false &&
                    $v.formData.travelerTypes.$model != '',
                }"
              />
              <div class="invalid-feedback">Please select a Target Group.</div>
            </fieldset>
            <fieldset>
              <legend>Main Image</legend>
              <div>
                <ImageUploadButton
                  ref="imageUploader"
                  :imageUrl="
                    formData && formData.mainImageUrl
                      ? formData.mainImageUrl
                      : ''
                  "
                  @clear="onClearUploadImage"
                />
              </div>
            </fieldset>
            <fieldset>
              <legend>Story*</legend>
              <div class="form-group row">
                <div class="col-md-12">
                  <ckeditor
                    :editor="editor"
                    v-model="$v.formData.content.$model"
                    :config="editorConfig"
                    style="color: #000"
                    :class="{
                      'is-invalid': $v.formData.content.$error,
                      'is-valid':
                        $v.formData.content.$error == false &&
                        $v.formData.content.$model != '',
                    }"
                    @ready="onEditorReady"
                  ></ckeditor>
                  <div class="invalid-feedback">Please enter a Story.</div>
                </div>
              </div>
            </fieldset>
            <fieldset>
              <legend>Affiliations</legend>
              <div class="row">
                <div class="col-md-6">
                  <div class="form-check ml-5">
                    <input
                      class="form-check-input"
                      type="radio"
                      name="affiliationAutoApproval"
                      :value="true"
                      style="margin-top: 10px"
                      v-model="formData.settings.experienceConnectionAutoAccept"
                    />
                    <label class="form-check-label" for="examplecheckbox1">
                      Any experience can connect with my story without approval.
                    </label>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-check ml-5">
                    <input
                      class="form-check-input"
                      type="radio"
                      name="affiliationAutoApproval"
                      :value="false"
                      style="margin-top: 10px"
                      v-model="formData.settings.experienceConnectionAutoAccept"
                    />
                    <label class="form-check-label" for="examplecheckbox2">
                      Any experience can connect with my story only with my
                      approval.
                    </label>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <div class="row">
                    <label class="col-md-3 form-label">EXPERIENCES</label>
                    <div class="col-md-9">
                      <AffiliationPicker
                        :contentId="id"
                        buttonColor="var(--color-blue)"
                        @click:add="saveDraftWithoutClosing"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </fieldset>
            <fieldset>
              <legend>Distribution</legend>
              <div class="form-group row">
                <label
                  class="form-label col-md-3"
                  style="line-height: 1.2"
                ></label>
                <div class="col-md-9">
                  <DistributionPicker
                    :contentId="id"
                    buttonColor="var(--color-blue)"
                    @click:add="saveDraftWithoutClosing"
                  />
                </div>
              </div>
            </fieldset>
            <EnwokeDeclarationFieldset
              v-model="formData.isAcceptedEnwokeAgreement"
              @delete="onDelete"
              contentName="story"
            />
            <div class="row">
              <div class="col-md-3">
                <input
                  type="submit"
                  class="btn btn-primary form-control"
                  value="Save &amp; Publish"
                  @click="saveAndPublish"
                  :disabled="!formData.isAcceptedEnwokeAgreement"
                />
              </div>
              <div class="col-md-3">
                <button
                  class="btn btn-secondary form-control"
                  @click="unpublish"
                  :disabled="!formData.isAcceptedEnwokeAgreement"
                >
                  Unpublish
                </button>
              </div>
              <div class="col-md-3">
                <button
                  class="btn btn-secondary form-control"
                  @click="saveDraft"
                  :disabled="!formData.isAcceptedEnwokeAgreement"
                >
                  Save
                </button>
              </div>
              <div class="col-md-3">
                <button
                  class="btn btn-secondary close-button form-control"
                  @click="onClickCloseButton"
                >
                  Close
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { required, email, decimal } from "vuelidate/lib/validators";
import TravelerTypePicker from "@/components/TravelerTypePicker";
import DateRangeControl from "@/components/DateRangeControl";
import ImageUploadButton from "@/components/ImageUploadButton";
import ExperiencePicker from "@/components/ExperiencePicker";
import AffiliationPicker from "@/components/AffiliationPicker";
import GroupPicker from "@/components/GroupPicker";
import DistributionPicker from "@/components/DistributionPicker";
import EnwokeDeclarationFieldset from "@/components/EnwokeDeclarationFieldset";
import _ from "lodash";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import AddContentButton from "@/components/AddContentButton";

export default {
  name: "StoriesForm",
  components: {
    TravelerTypePicker,
    DateRangeControl,
    ImageUploadButton,
    ExperiencePicker,
    AffiliationPicker,
    GroupPicker,
    DistributionPicker,
    EnwokeDeclarationFieldset,
    AddContentButton,
  },
  props: {
    content: {
      type: Object,
    },
  },
  data() {
    return {
      date: "",
      time: "",
      status: "now",
      formData: {
        id: null,
        name: "",
        title: "",
        description: "",
        content: "",
        thumbnailUrl: "",
        author: {
          screenName: "",
          picture: "",
        },
        categories: [],
        travelerTypes: [],
        mainImageUrl: "",
        thumbnailUrl: "",
        isAcceptedEnwokeAgreement: false,
        status: "PUBLISH",
        publishDate: "",
        settings: {
          experienceConnectionAutoAccept: true,
        },
      },
      editor: ClassicEditor,
      editorConfig: {
        // The configuration of the rich-text editor.
      },
    };
  },
  computed: {
    id() {
      return this.content ? this.content.id : this.formData.id;
    },
  },
  validations: {
    date: {
      required,
    },
    time: {
      required,
    },
    formData: {
      title: {
        required,
      },
      travelerTypes: {
        required,
      },
      content: {
        required,
      },
      author: {
        screenName: {
          required,
        },
      },
    },
  },
  methods: {
    onEditorReady() {
      if (this.content) {
        this.prepare(this.content);
      }
    },
    prepare(content) {
      const formData = _.merge({}, content); // Create a copy.
      if (formData.experiences && formData.experiences.results) {
        formData.experiences = formData.experiences.results;
      }
      if (formData.travelerTypes && formData.travelerTypes.length > 0) {
        formData.travelerTypes = formData.travelerTypes.map((it) => it.id);
      }
      this.formData = formData;
    },
    async uploadImages() {
      if (this.$refs.imageUploader) {
        return this.$refs.imageUploader.upload();
      } else {
        return null;
      }
    },
    async uploadImagesAuthor() {
      if (this.$refs.imageAuthorUploader) {
        return this.$refs.imageAuthorUploader.upload();
      } else {
        return null;
      }
    },
    onSubmit(ev) {
      ev.preventDefault();
    },
    saveAndPublish(ev) {
      this.save("PUBLISH");
    },
    saveDraft() {
      this.save("DRAFT");
    },
    saveDraftWithoutClosing() {
      this.save("DRAFT", false);
    },
    unpublish() {
      this.save("UNPUBLISH");
    },
    async save(status = "PUBLISH", closeAfterSave = true) {
      if (status === "PUBLISH" && !this.formData.isAcceptedEnwokeAgreement)
        return;

      if (!this.formData.title || this.formData.title.trim() === "") {
        this.formData.title = "Untitled";
      }

      this.formData.status = status;

      const files = await this.uploadImages();
      if (files && files.length > 0) {
        this.formData.mainImageUrl = files[0].url;
        this.formData.thumbnailUrl = files[0].url;
      }

      if (this.status == "schedule") {
        if (this.date != "" && this.time != "") {
          const publishDate = new Date(this.date + " " + this.time);
          this.formData.publishDate = publishDate.toJSON();
        } else {
          this.formData.publishDate = "";
        }
      } else {
        this.formData.publishDate = "";
      }

      let promise = null;
      let saveData = _.merge({}, this.formData); // Clone data for saving.

      // Re-shape experience for saving.
      if (saveData.experiences && saveData.experiences.length > 0) {
        saveData.experiences = saveData.experiences.map((it) => it.id);
      }

      delete saveData.author;
      saveData.customAuthor = {
        name: this.formData.author.screenName,
        picture: "",
      };
      const filesAuthor = await this.uploadImagesAuthor();
      if (filesAuthor && filesAuthor.length > 0) {
        saveData.customAuthor.picture = filesAuthor[0].url;
      }

      if (this.formData.id) {
        promise = this.$repo.story.updateStory(saveData);
      } else {
        promise = this.$repo.story.createStory(saveData);
      }

      promise
        .then((data) => {
          this.formData.id = data.id;
          if (closeAfterSave) {
            this.$toasted.show("Save data successfully.", {
              type: "success",
              duration: 3000,
              position: "bottom-right",
            });
            this.closeForm();
          }
        })
        .catch((err) => {
          console.error(err);
          if (closeAfterSave) {
            this.$toasted.show("Something went wrong.", {
              type: "error",
              duration: 3000,
              position: "bottom-right",
            });
          }
        });
    },
    async onDelete() {
      if (this.id) {
        await this.$repo.story.deleteStory(this.id);
        this.closeForm();
      }
    },
    onClearUploadImageAuthor() {
      this.form.author.picture = "";
    },
    onClearUploadImage() {
      this.formData.mainImageUrl = "";
      this.formData.thumbnailUrl = "";
    },
    onClickCloseButton(ev) {
      ev.preventDefault();
      this.closeForm();
    },
    closeForm() {
      this.$emit("close");
    },
    resetDatetime() {
      this.date = "";
      this.time = "";
    },
  },
};
</script>

<style lang="scss">
$main-color: #1877f2;
.modal-form {
  color: #000;

  legend,
  .form-label,
  .form-check-label,
  .declaration-fieldset {
    color: #fff;
  }

  .table-experience {
    width: 100%;
    color: #fff;
  }
}
#offer-form {
  .form-title {
    color: $main-color;
  }

  .label-icon-box {
    background-color: #b9b9b9;
    color: #fff;
    display: inline-block;
    width: 40px;
    height: 40px;
    vertical-align: middle;
    margin-right: 10px;
    text-align: center;
    position: relative;

    .label-icon {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }
  .label-icon {
    font-size: 2rem;
  }

  #experience-form .form-title {
    color: $main-color;
  }

  input[type="submit"].btn-primary {
    background-color: $main-color;
    border-color: $main-color;
  }

  .experience-picker .vue-tags-input .ti-tag,
  .experience-picker .vue-tags-input .ti-selected-item,
  .picker-control li.selected {
    background-color: $main-color;
    border-color: $main-color;
  }

  .form-check-label {
    font-size: 14px;
  }

  .form-control {
    border-radius: 0;
  }

  .ck-editor__editable {
    min-height: 200px;
  }
}
</style>
